import React, { FC } from "react";
import { SubscriptionIconSvg } from "../../../../components/icons";
import { convertFromCentsToDollars } from "../../../../helpers/currency";
import {
  SubscriptionMetadata,
  DiscountType,
} from "../../../../types/graphql/generated";
import {
  StyledInterval,
  StyledSubscribe,
  StyledSubscribeDetails,
  StyledSubscribeLogo,
} from "./index.styled";

interface SubscriptionDetailsProps {
  subscription?: SubscriptionMetadata | null;
}

export const SubscriptionDetails: FC<SubscriptionDetailsProps> = ({
  subscription,
}) => {
  const { discountAmount, discountType, subscriptionIntervalInDays } =
    subscription || {};
  const discountLabel =
    (discountAmount &&
      (discountType === DiscountType.Percent
        ? `& save ${discountAmount}%`
        : `& save ${convertFromCentsToDollars(discountAmount)}`)) ||
    "";

  return (
    <StyledSubscribe>
      <StyledSubscribeLogo>
        <SubscriptionIconSvg />
      </StyledSubscribeLogo>
      <StyledSubscribeDetails>
        <div>{`Subscribe ${discountLabel}`}</div>
        <StyledInterval>
          Deliver every {subscriptionIntervalInDays} days
        </StyledInterval>
      </StyledSubscribeDetails>
    </StyledSubscribe>
  );
};
